const NAME_STYLE = { fontSize: 12.5, fontWeight: 700, color: 'var(--nb-ink)' } as const;

/** The customer's name. For people who may manage replacements it is the row's
 *  keyboard-reachable edit control; clicks anywhere on the row land here too. */
export function TreeReplacementName({ name, editable }: { name: string; editable: boolean }) {
  if (!editable) return <div style={{ ...NAME_STYLE, gridArea: 'name', minWidth: 0 }}>{name}</div>;
  return (
    <button
      type="button"
      aria-label={`Edit replacement for ${name}`}
      style={{
        ...NAME_STYLE,
        gridArea: 'name',
        minWidth: 0,
        padding: 0,
        border: 'none',
        background: 'transparent',
        textAlign: 'left',
        cursor: 'pointer',
        font: 'inherit',
        fontWeight: 700,
      }}
    >
      {name}
    </button>
  );
}
